import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getConnectionRequiredDialogOpen } from '../Selectors'
import { setConnectionRequiredDialog } from '../ActionCreators'
import ConnectionRequiredModal from '../../components/Modals/ConnectionRequiredModal'

/**
 * Modal for when attempting to ping to cloud printer while offline
 *
 * @returns {React.Element}
 */
export const VNConnectionRequired = () => {
  const dispatch = useDispatch()
  const options = useSelector(getConnectionRequiredDialogOpen)

  const cancelHandler = useCallback(() => {
    dispatch(setConnectionRequiredDialog({ open: false }))
  }, [dispatch])

  if (!options?.get('open')) {
    return null
  }

  // TODO: refactor component to use VNDialogs with equivalent styling
  return <ConnectionRequiredModal subtext={options?.get('subtext')} onButtonClick={cancelHandler} />
}
